module.exports = __webpack_public_path__ + "img/Pilz.f1bbde1f.svg";